import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { PersistenceService } from './persistence.service';
import { StoredUser } from 'src/app/interfaces/app.interface';
import { AuthService } from '../../auth/services/auth.service';
import { TenantContextService } from './tenant-context.service';
import { authLog, describeHttpError } from '../../auth/helpers/auth-diagnostics.util';
import { FileAccessService } from '../../../services/file-access.service';

@Injectable({
  providedIn: 'root',
})
export class SystemUserService {
  constructor(
    private router: Router,
    private persistenceService: PersistenceService,
    private injector: Injector
  ) {}

  getCurrentUser = (): StoredUser => this.persistenceService.get('user');

  getAccessToken = (): string => this.persistenceService.get('accessToken');

  getRefreshToken = (): string => this.persistenceService.get('refreshToken');

  logout(b: boolean = true): boolean {
    this.injector.get(FileAccessService).clearAll();
    const hasActiveSession = Boolean(this.getAccessToken());
    const refreshToken = this.getRefreshToken();
    authLog('warn', 'crm.logout.start', {
      hasActiveSession,
      hasRefreshToken: !!refreshToken,
      navigateToLogin: b,
    });

    if (refreshToken) {
      this.injector
        .get(AuthService)
        .revokeRefreshToken(refreshToken)
        .subscribe({
          next: () => {
            authLog('info', 'crm.logout.revoke_request.completed', {
              hadRefreshToken: true,
            });
          },
          error: (error) => {
            authLog('warn', 'crm.logout.revoke_request.error', {
              error: describeHttpError(error),
            });
          },
        });
    }

    this.persistenceService.remove('user');
    this.persistenceService.remove('accessToken');
    this.persistenceService.remove('refreshToken');
    authLog('info', 'crm.logout.local_storage_cleared', {
      hadActiveSession: hasActiveSession,
      hadRefreshToken: !!refreshToken,
    });

    if (!hasActiveSession) {
      authLog('info', 'crm.logout.no_active_session', {
        hadRefreshToken: !!refreshToken,
      });
      return false;
    }

    this.injector.get(AuthService).resetSessionState();
    this.injector.get(TenantContextService).clearSelectedTenant();

    if (b) {
      authLog('info', 'crm.logout.navigate_login', {});
      this.router.navigate(['/auth/login']);
    }

    return true;
  }
}
